export interface RoofingSystem {
  id: string;
  name: string;
  blurb: string;
  detail: string;
  // Empty string renders a branded placeholder panel instead of a photo.
  // Only genuinely-matching photography belongs here — a cabin captioned "Tile"
  // misleads a homeowner picking a material. Replace with Cates' own job photos.
  image: string;
  highlights: string[];
  featured?: boolean;
}

// Four categories, in this order, per client direction 2026-08-17.
export const ROOFING_SYSTEMS: RoofingSystem[] = [
  {
    id: 'architectural-shingles',
    name: 'Architectural Shingles',
    blurb: 'The roofing system we install most, and a great fit for most Florida homes.',
    detail: 'Architectural shingles offer strong wind performance, excellent durability, and a wide range of styles. We install them as a complete roofing system, including underlayment, starter shingles, flashing, and proper ventilation.',
    image: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=900&auto=format&fit=crop&q=80',
    highlights: ['Excellent value', 'Built for Florida weather', 'Wide color selection'],
    featured: true,
  },
  {
    id: 'cedar-shake-designer',
    name: 'Cedar Shake / Designer',
    blurb: 'Distinctive roofing options for homeowners who want more character and curb appeal.',
    detail: 'Natural cedar offers a timeless look that ages beautifully, while designer shingles can achieve a similar high end appearance with modern roofing performance. We’ll help you choose the right option for your home and install it correctly for long term performance.',
    image: 'https://images.unsplash.com/photo-1595877244574-e90ce41ce089?w=900&auto=format&fit=crop&q=80',
    highlights: ['Natural cedar or designer shingles', 'Distinctive, high end appearance', 'Expert installation for lasting performance'],
  },
  {
    id: 'slate-tile',
    name: 'Slate / Tile',
    blurb: 'Premium roofing systems known for exceptional durability, longevity, and timeless style.',
    detail: 'Clay and concrete tile perform exceptionally well in Florida’s climate, while natural slate can last for generations. Because these roofing systems are heavier than traditional shingles, we assess your home’s structure and recommend the right system before installation.',
    image: '',
    highlights: ['Exceptional durability', 'Fire resistant', 'Structural assessment included'],
  },
  {
    id: 'metal-roofing',
    name: 'Metal Roofing',
    blurb: 'Built for long term performance, with exceptional wind resistance and a clean, modern look.',
    detail: 'Standing seam metal roofing is designed to handle Florida’s demanding weather while reflecting heat and providing decades of reliable protection. Concealed fasteners add durability and create the clean, finished appearance metal roofing is known for.',
    image: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=900&auto=format&fit=crop&q=80',
    highlights: ['Exceptional wind resistance', 'Energy efficient', '40–70 year service life'],
  },
];

// Storm response capability list.
export const STORM_CAPABILITIES = [
  'Wind Damage',
  'Hail Damage',
  'Storm & Hurricane Damage',
  'Emergency Tarping',
  'Post-Storm Inspections',
  'Damage Documentation',
  'Insurance Claim Assistance',
];

// The insurance-claim journey. Reworded 2026-08-17 into a more polished,
// professional register that reads as one continuous process; step 01 wording
// supplied by the client.
export const CLAIM_STEPS = [
  {
    step: '01',
    title: 'Complimentary Roof Inspection',
    text: 'We thoroughly inspect your roof to identify damage and determine whether an insurance claim may be warranted.',
  },
  {
    step: '02',
    title: 'Comprehensive Damage Documentation',
    text: 'Every finding is photographed, measured and compiled into a detailed report prepared to the standard your carrier expects.',
  },
  {
    step: '03',
    title: 'Adjuster Meeting',
    text: 'We meet your adjuster on site and walk the roof alongside them, ensuring the full extent of the damage is recognised and recorded.',
  },
  {
    step: '04',
    title: 'Claim Management',
    text: 'We manage the correspondence, supplements and approvals on your behalf, keeping the claim moving without it becoming your responsibility.',
  },
  {
    step: '05',
    title: 'Professional Installation',
    text: 'Our own crews complete the approved scope to manufacturer specification, and we provide full photo documentation of the finished roof for your records.',
  },
];
